import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnerIdFragmentGql } from './OwnerIdFragmentGql';

// Should fetch same nodes as FlowDownstreamOwnersQuery
export const FlowDownstreamOwnerIdsQueryGql: DocumentNode = gql`
query FlowDownstreamOwnerIdsQuery($flowVizportalUrlId: String!, $first: Int!, $offset: Int!) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerIdFragment
      }
    }
  }
}
${OwnerIdFragmentGql}
`;
